import { URL } from 'url';

export default function redirect({
  destination,
  callback,
  replace,
  forceRefresh = false,
}) {
  if (global.BROWSER) {
    if (destination.startsWith('http') || forceRefresh) {
      return window.location.replace(destination);
    }

    replace(destination);
    return callback();
  }

  const parsedHref = new URL(destination);
  replace({
    pathname: parsedHref.pathname,
    search: parsedHref.search,
    host: parsedHref.host,
    protocol: parsedHref.protocol,
    state: parsedHref,
  });
  return callback();
}
